import { render, staticRenderFns } from "./GestioneFiscale.vue?vue&type=template&id=49853340&"
import script from "./GestioneFiscale.vue?vue&type=script&lang=js&"
export * from "./GestioneFiscale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports